'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _DragConfig = require('./DragConfig');

var _createScroll = require('./steppers/createScroll');

var _createScroll2 = _interopRequireDefault(_createScroll);

var _createSpring = require('./steppers/createSpring');

var _createSpring2 = _interopRequireDefault(_createSpring);

var _Friction3 = require('./steppers/Friction');

var _Friction4 = _interopRequireDefault(_Friction3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function getPageTarget(x, v, config) {
  var pageSize = config.pageSize;
  var min = config.min;
  var max = config.max;
  var pageIndex = Math.min(Math.max(Math.round((x - min) / pageSize + Math.min(Math.max(v, -0.5), 0.5)), 0), (max - min) / pageSize);
  return min + pageIndex * pageSize;
}

function getMomentumFunction(x, v, config) {
  if (config && config.momentum === true) {
    var pageSize = config.pageSize;

    if (pageSize) {
      return (0, _createSpring2.default)(getPageTarget(x, v, config), 0.0001, 0.02);
    } else if (config.min != null || config.max != null) {
      return (0, _createScroll2.default)(config);
    }
    return _Friction4.default;
  }
  return function (x, v, elapsed, dt) {
    return [x, 0, true];
  };
}

var STEPS_PER_SEC = 60;
var SEC_PER_STEP = 1 / STEPS_PER_SEC;

var DragMomentumAnimator = function () {
  function DragMomentumAnimator(xConfig, yConfig) {
    var _this = this;

    _classCallCheck(this, DragMomentumAnimator);

    this._tick = function () {
      var now = Date.now();
      var shouldStop = false;
      var stepsNeeded = (now - _this._startTime) / 1000 / SEC_PER_STEP - _this._stepsCompleted;

      for (var i = 0; i < stepsNeeded && !shouldStop; i++) {
        var nextP = void 0;
        var nextV = void 0;
        if (_this._xConfig && _this._xConfig.momentum === true && _this._yConfig && _this._yConfig.momentum === true && _this._v.x && _this._v.y && !(0, _DragConfig.isConstrained)(_this._p.x, _this._xConfig) && !(0, _DragConfig.isConstrained)(_this._p.y, _this._yConfig)) {
          var vHypotenuse = Math.sqrt(_this._v.x * _this._v.x + _this._v.y * _this._v.y);

          var _Friction = (0, _Friction4.default)(0, vHypotenuse, SEC_PER_STEP, now - _this._startTime),
              _Friction2 = _slicedToArray(_Friction, 3),
              _ = _Friction2[0],
              nextVHyp = _Friction2[1],
              shouldStopHyp = _Friction2[2];

          nextV = {
            x: _this._v.x / vHypotenuse * nextVHyp,
            y: _this._v.y / vHypotenuse * nextVHyp
          };
          nextP = {
            x: _this._p.x + nextV.x * SEC_PER_STEP,
            y: _this._p.y + nextV.y * SEC_PER_STEP
          };
          shouldStop = shouldStopHyp;
        } else {
          var _fX = _this._fX(_this._p.x, _this._v.x, SEC_PER_STEP, now - _this._startTime),
              _fX2 = _slicedToArray(_fX, 3),
              _x = _fX2[0],
              vX = _fX2[1],
              shouldStopX = _fX2[2];

          var _fY = _this._fY(_this._p.y, _this._v.y, SEC_PER_STEP, now - _this._startTime),
              _fY2 = _slicedToArray(_fY, 3),
              y = _fY2[0],
              vY = _fY2[1],
              shouldStopY = _fY2[2];

          nextP = { x: _x, y: y };
          nextV = { x: vX, y: vY };
          shouldStop = shouldStopX && shouldStopY;
        }
        _this._p = nextP;
        _this._v = nextV;
      }

      _this._stepsCompleted += stepsNeeded;
      _this._updater(_this._p);
      if (!shouldStop) {
        _this._raf = window.requestAnimationFrame(_this._tick);
      } else {
        _this._onEnd && _this._onEnd(_this._p);
      }
    };

    this._xConfig = xConfig;
    this._yConfig = yConfig;
  }

  _createClass(DragMomentumAnimator, [{
    key: 'start',
    value: function start(p, v, updater, onEnd) {
      this._p = p;
      this._v = v;
      this._updater = updater;
      this._onEnd = onEnd;
      this._fX = getMomentumFunction(p.x, v.x, this._xConfig);
      this._fY = getMomentumFunction(p.y, v.y, this._yConfig);

      this._startTime = Date.now();
      this._stepsCompleted = 0;
      this._tick();
    }
  }, {
    key: 'stop',
    value: function stop() {
      window.cancelAnimationFrame(this._raf);
    }
  }]);

  return DragMomentumAnimator;
}();

exports.default = DragMomentumAnimator;


//////////////////
// WEBPACK FOOTER
// ./~/buttery/lib/DragMomentumAnimator.js
// module id = 167
// module chunks = 0